import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmSelect from '~/components/atoms/MdmSelect.vue';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  components: {
    GlobalTitle: GlobalTitle,
    MdmSelect: MdmSelect
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      currentShop: '',
      baseURL: 'http://www.clicrdv.com/maisons-du-monde-',
      shops: [{
        name: 'Les Clayes Sous Bois',
        url: 'Les-Clayes-Sous-Bois'
      }, {
        name: 'Herblay',
        url: 'Herblay'
      }, {
        name: 'Montévrain',
        url: 'Montevrain'
      }, {
        name: 'Paris Montmartre',
        url: 'Paris-Montmartre'
      }, {
        name: 'Toulon La Garde',
        url: 'Toulon-La-Garde'
      }, {
        name: 'Paris Wagram',
        url: 'Paris-Wagram'
      }, {
        name: 'Bordeaux Lac',
        url: 'Bordeaux-Lac'
      }, {
        name: 'Paris Beaugrenelle',
        url: 'Paris-Beaugrenelle'
      }, {
        name: 'Cannes',
        url: 'Cannes-Mandelieu'
      }, {
        name: 'Boulogne-Billancourt',
        url: 'Boulogne-Billancourt'
      }, {
        name: 'Paris Rue Du Bac',
        url: 'Paris-Rue-Du-Bac'
      }]
    };
  },
  computed: {
    title: function title() {
      return this.payload.primary.title[0];
    }
  },
  methods: {
    goToPage: function goToPage() {
      window.location.href = "".concat(this.baseURL).concat(this.shops[this.currentShop].url);
    }
  }
};